module.exports = __webpack_public_path__ + "static/media/daffodil.8bac5739.jpeg";